import React, { useContext, useEffect, useRef, useState } from "react";
import "./FanCoil.css";
import CircleSlider from "./Sliders/CircleSlider";
import { Context } from "../../../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const FanCoil = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data: finalData,
  setData: setFinalData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [data, setData] = useState({
    state: 1,
    temp: 10,
    mode: 2,
    speed: 0,
  });

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleFanSpeed = (speed) => {
    setData((prev) => ({
      ...prev,
      speed,
    }));
  };

  const handleFanMode = (mode) => {
    setData((prev) => ({
      ...prev,
      mode,
    }));
  };

  const handleSliderValue = (val) => {
    setData((prev) => ({
      ...prev,
      temp: val[0].value,
    }));
  };

  const handleFanState = () => {
    setData((prev) => ({
      ...prev,
      state: prev.state ? 0 : 1,
    }));
  };

  const handleSubmit = () => {
    console.log(data);
    const button = buttons[0];
    const device = devices.find((dev) => dev.id == button.device_id);
    if (!device) {
      return;
    }
    let mod =
    (data.state ? "1" : "0") +
    data.mode.toString(2).padStart(2, "0") +
    data.speed.toString(2).padStart(2, "0");
    mod = mod.padStart(8, "0");
    let data1 = button.digit + 6;
    let data2 = parseInt(mod, 2);
    let data3 = data.temp * 2;
    let data4 = 0;
    setFinalData({
      icon: null,
      name: button.name,
      data: [2, data1, data2, data3, data4],
      device: device,
    });
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => (
      <div className="row fan-coil-box rounded-3" key={button.id}>
        <div className="col-12">
          <p className="text-end text-secondary" style={{fontSize: '11px'}}>
            C{button.name}-S/
            {devices.find((d) => d.id == button.device_id)?.serial}
          </p>
        </div>
        <div className="col-12 text-center slider-power">
          <CircleSlider
            value={[{ value: data.temp }]}
            setValue={handleSliderValue}
            isDisable={data.state ? false : true}
          />
          <div className="power-key" onClick={() => handleFanState()}>
            <img
              src="/assets/img/app-icons/Li1.png"
              style={{ width: "4rem" }}
              alt=""
            />
          </div>
        </div>
        <div className="d-flex justify-content-around align-items-center options">
          <div onClick={() => handleFanSpeed(3)}>
            <img
              src={
                data.speed == 3 && data.state
                  ? "/assets/img/app-icons/IY.png"
                  : "/assets/img/app-icons/IY-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanSpeed(2)}>
            <img
              src={
                data.speed == 2 && data.state
                  ? "/assets/img/app-icons/0P.png"
                  : "/assets/img/app-icons/0P-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanSpeed(1)}>
            <img
              src={
                data.speed == 1 && data.state
                  ? "/assets/img/app-icons/0P1.png"
                  : "/assets/img/app-icons/0P1-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanSpeed(0)}>
            <img
              src={
                data.speed == 0 && data.state
                  ? "/assets/img/app-icons/0P2.png"
                  : "/assets/img/app-icons/0P2-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
        </div>
        <div className="d-flex justify-content-around align-items-center options">
          <div onClick={() => handleFanMode(3)}>
            <img
              src={
                data.mode == 3 && data.state
                  ? "/assets/img/app-icons/Eg.png"
                  : "/assets/img/app-icons/Eg-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanMode(1)}>
            <img
              src={
                data.mode == 1 && data.state
                  ? "/assets/img/app-icons/ex.png"
                  : "/assets/img/app-icons/ex-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanMode(0)}>
            <img
              src={
                data.mode == 0 && data.state
                  ? "/assets/img/app-icons/J4.png"
                  : "/assets/img/app-icons/J4-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
          <div onClick={() => handleFanMode(2)}>
            <img
              src={
                data.mode == 2 && data.state
                  ? "/assets/img/app-icons/5Q1.png"
                  : "/assets/img/app-icons/5Q1-1.png"
              }
              style={{ width: "3rem" }}
              alt=""
            />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0"
        style={{ zIndex: 1, top: '0' }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
          {renderButtons()}
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(FanCoil);
